<template>
  <div>
    <template v-if="data.refundable">
      <div
        v-if="data.cancellationPolicies && data.cancellationPolicies.cancelPolicyInfos"
      >
        <div
          v-for="(policy, index) in data.cancellationPolicies.cancelPolicyInfos"
          :key="index"
          :class="{'pt-2': index }"
        >
          <div class="d-flex align-center justify-space-between font-weight-bold">
            <span>{{ $t(index ? 'Cancel after' : 'Cancel by') }} {{ policy.cancelDate }}</span>
            <span
              class="text-right"
              :class="{ 'green--text text--lighten-1': !policy.cancelAmount }"
            >
              <template v-if="!policy.cancelAmount">{{ $t('Free cancellation') }}</template>
              <template v-else>{{ getCurrencySymbol(policy.currency) }} {{ policy.cancelAmount }}</template>
            </span>
          </div>

          <div class="d-flex align-center justify-space-between grey--text text--darken-1">
            <span>{{ policy.cancelHour }}</span>
            <span class="text-right">
              <template v-if="!policy.cancelAmount">{{ $t('Full refund') }}</template>
              <template v-else-if="policy.cancelAmount === data.priceWithTax">{{ $t('No refund') }}</template>
              <template v-else>{{ getCurrencySymbol(policy.currency) }} {{ policy.cancelRefund }} {{ $t('refund') }}</template>
            </span>
          </div>

          <v-divider
            v-if="index !== data.cancellationPolicies.cancelPolicyInfos.length - 1"
            class="mt-2"
          />
        </div>
      </div>
    </template>

    <template v-else>
      <div class="d-flex align-center font-weight-bold">
        <v-icon class="mr-2">mdi-information</v-icon>
        {{ $t('Non-refundable') }}
      </div>
      <p class="text-body-2 grey--text text--darken-1 mt-1">
        {{ $t('non_refundable_description') }}
      </p>
    </template>
  </div>
</template>

<script>
import CurrencyMixin from '@/lib/CurrencyMixin';

export default {
  mixins: [CurrencyMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
